import * as espree from 'espree'
import { walk } from 'estree-walker'
import _ from 'lodash'

//
// Checkers
//
const Check = {
  isMemberAccess: (node, module, method) => {
    return (
      node &&
      node.type === 'MemberExpression' &&
      node.object &&
      node.object.type === 'Identifier' &&
      node.object.name === module &&
      node.property &&
      (!method || (node.property.type === 'Identifier' && node.property.name === method))
    )
  },

  isFieldAccess: node => {
    return Check.isMemberAccess(node, 'Fields')
  },

  isInvocation: (node, module, method) => {
    return node.type === 'CallExpression' && Check.isMemberAccess(node.callee, module, method)
  }
}

const genContext = (code, node) => {
  // Get relevant lines from flow
  const allLines = _.split(code, '\n')
  const initialLineNo = node.loc.start.line - 1
  const finalLineNo = node.loc.end.line - 1
  var lines = _.filter(allLines, (_, lineNo) => lineNo >= initialLineNo && lineNo <= finalLineNo)

  // Do last line first
  const lastLine = lines[lines.length - 1]
  lines[lines.length - 1] = [
    ...lastLine.slice(0, node.loc.end.column),
    ...'</em>',
    ...lastLine.slice(node.loc.end.column, lastLine.length)
  ]

  // Do first line last
  const firstLine = lines[0]
  lines[0] = [
    ...firstLine.slice(0, node.loc.start.column),
    ...'<em>',
    ...firstLine.slice(node.loc.start.column, firstLine.length)
  ]

  // add some context before and after
  if (initialLineNo > 1) {
    lines.unshift(allLines[initialLineNo - 1])
  }

  if (finalLineNo < allLines.length - 1) {
    lines.push(allLines[finalLineNo + 1])
  }

  return lines.map((l, i) => `${initialLineNo + i}: ${l.join ? l.join('') : l}`).join('<br/>')
}

const checkForInvocation = (flowId, code, { module, method }, results) => {
  const ast = espree.parse(code, { loc: true })
  walk(ast, {
    enter(node, parent, prop, index) {
      if (Check.isInvocation(node, module, method)) {
        results({ flowId, context: genContext(code, node) })
      }
    }
  })
}

onmessage = event => {
  if (event.data.job) {
    const { flowId, code, invocation } = event.data.job
    try {
      checkForInvocation(flowId, code, invocation, postMessage)
      postMessage({ done: true })
    } catch (err) {
      postMessage({ done: true, error: err.message })
    }
  }
}

export default {
  forTest: {
    checkForInvocation
  }
}
